module.exports = __webpack_public_path__ + "static/img/banner1.51c2ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selfPrinting/banner1.png
// module id = 1ZnC
// module chunks = 10